import { render, staticRenderFns } from "./ProductIngredients.vue?vue&type=template&id=e5ef2b86&"
import script from "./ProductIngredients.vue?vue&type=script&lang=js&"
export * from "./ProductIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports